import { z } from 'zod'

import { http } from '@/shared/api'

export type Broadcast = {
  id: string
  titleRu: string
  titleEn: string
  bodyRu: string
  bodyEn: string
  isGlobal: boolean
  createdByEmail: string
  recipientCount: number
  readCount: number
  createdAt: string
}

const itemSchema = z.object({
  ID: z.string(),
  TitleRU: z.string(),
  TitleEN: z.string(),
  BodyRU: z.string(),
  BodyEN: z.string(),
  IsGlobal: z.boolean(),
  CreatedByEmail: z.string(),
  RecipientCount: z.number(),
  ReadCount: z.number(),
  CreatedAt: z.string(),
})

// Bare array, PascalCase.
const listSchema = z.array(itemSchema).nullable()

export async function fetchBroadcasts(
  params: { limit: number; offset: number },
  signal?: AbortSignal,
): Promise<Broadcast[]> {
  const raw = await http.get('admin/notifications', {
    searchParams: { limit: params.limit, offset: params.offset },
    schema: listSchema,
    signal,
  })

  return (raw ?? []).map((entry) => ({
    id: entry.ID,
    titleRu: entry.TitleRU,
    titleEn: entry.TitleEN,
    bodyRu: entry.BodyRU,
    bodyEn: entry.BodyEN,
    isGlobal: entry.IsGlobal,
    createdByEmail: entry.CreatedByEmail,
    recipientCount: entry.RecipientCount,
    readCount: entry.ReadCount,
    createdAt: entry.CreatedAt,
  }))
}

const createdSchema = z.object({ broadcast_id: z.string() })

export async function createBroadcast(input: {
  titleRu: string
  titleEn: string
  bodyRu: string
  bodyEn: string
  userIds: string[]
}): Promise<string> {
  const { broadcast_id } = await http.post('admin/notifications', {
    json: {
      title_ru: input.titleRu,
      title_en: input.titleEn,
      body_ru: input.bodyRu,
      body_en: input.bodyEn,
      // Empty means a global broadcast to all active users.
      ...(input.userIds.length > 0 && { user_ids: input.userIds }),
    },
    schema: createdSchema,
  })
  return broadcast_id
}
